import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/bulb.png'


const _withScopeId = n => (_pushScopeId("data-v-1c55d260"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "__side-menu" }
const _hoisted_2 = { class: "__wrapper" }
const _hoisted_3 = { class: "__side-menu__header p-6 pr-0 uppercase flex justify-between items-center text-neutral-400 text-xs font-semibold" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Cơ sở giáo dục", -1))
const _hoisted_5 = { class: "__side-menu__content" }
const _hoisted_6 = { class: "__side-menu__brand p-6 flex items-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "font-medium leading-none text-white" }
const _hoisted_9 = { class: "ml-4 font-semibold text-neutral-600 w-32" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "__side-menu__menu" }
const _hoisted_13 = { class: "__menu__group" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "flex flex-nowrap items-center" }
const _hoisted_16 = {
  class: "font-semibold ml-3",
  style: {"font-size":"14px"}
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "__side-menu__subs"
}
const _hoisted_19 = { class: "flex flex-nowrap items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-4" }, null, -1))
const _hoisted_21 = {
  class: "font-semibold ml-3",
  style: {"font-size":"14px"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line bg-neutral-200 block mx-auto my-10",
  style: {"height":"1px","width":"200px"}
}, null, -1))
const _hoisted_23 = {
  key: 0,
  class: "px-6 pb-2 font-semibold text-neutral-500"
}
const _hoisted_24 = { class: "__menu__group" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "flex flex-nowrap items-center" }
const _hoisted_27 = {
  class: "font-semibold ml-3",
  style: {"font-size":"14px"}
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 1,
  class: "__side-menu__subs"
}
const _hoisted_30 = { class: "flex flex-nowrap items-center" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-4" }, null, -1))
const _hoisted_32 = {
  class: "font-semibold ml-3",
  style: {"font-size":"14px"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line bg-neutral-200 block mx-auto my-10",
  style: {"height":"1px","width":"200px"}
}, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-6 pb-2 font-semibold text-neutral-500" }, " Cá nhân ", -1))
const _hoisted_35 = { class: "__menu__group" }
const _hoisted_36 = { class: "__menu__wrapper mb-1" }
const _hoisted_37 = { class: "flex flex-nowrap items-center" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "font-medium leading-none text-white text-lg" }
const _hoisted_40 = {
  class: "font-semibold ml-3",
  style: {"font-size":"14px"}
}
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "font-normal text-xs" }
const _hoisted_44 = { class: "flex flex-nowrap items-center" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "font-semibold ml-3",
  style: {"font-size":"14px"}
}, " Đăng xuất ", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "__menu__item px-6 py-4 hover:bg-yellow-100 cursor-pointer text-neutral-500 justify-between flex flex-nowrap items-center",
  href: "https://wiki.luca.education/cac-ban-cap-nhat/website"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "",
        class: "w-4 h-4",
        src: _imports_0
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "font-semibold ml-3",
      style: {"font-size":"14px","color":"#e5a42b"}
    }, " Tìm hiểu tính năng mới ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", {
          class: "h-10 w-10 flex items-center justify-end cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('choose')))
        }, [
          _createVNode(_component_DaIcon, {
            class: "cursor-pointer w-1",
            name: "das--ellipsis"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            (_ctx.profile?.current_org?.profile_photo?.w200)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.profile?.current_org?.profile_photo?.w200,
                  alt: "",
                  class: "shadow-sm inline-block h-10 w-10 rounded-md"
                }, null, 8, _hoisted_7))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  style: _normalizeStyle({
								background:
									_ctx.profile?.current_org?.profile_photo?.default
										?.color,
							}),
                  class: "shadow-sm inline-flex items-center justify-center h-10 w-10 rounded-xl"
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.profile?.current_org?.profile_photo?.default
									?.initial), 1)
                ], 4))
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.profile?.current_org?.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.profile?.current_org?.name), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, "Tên trung tâm"))
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "__menu__wrapper mb-1",
                onClick: ($event: any) => (_ctx.subOpen(item.id))
              }, [
                (item.vIf)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (
										!item.guard ||
										item.guard.includes(
											_ctx.profile?.staff?.role
										)
									)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.link ? `router-link` : `div`), {
                            key: 0,
                            to: item.link
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass([[
											_ctx.haveSub(item.subs)
												? 'text-yellow-700'
												: '',
											_ctx.checkState(item.state)
												? 'grey-out'
												: '',
										], "__menu__item px-6 py-4 hover:bg-yellow-100 cursor-pointer text-neutral-500 justify-between flex flex-nowrap items-center"])
                              }, [
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_DaIcon, {
                                      name: item.icon,
                                      class: "w-4"
                                    }, null, 8, ["name"])
                                  ]),
                                  _createElementVNode("div", _hoisted_16, _toDisplayString(item.name), 1)
                                ]),
                                (item.subs)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                      _createVNode(_component_DaIcon, {
                                        class: _normalizeClass([[
													_ctx.isSubOpen === item.id ||
													_ctx.haveSub(item.subs)
														? 'rotate-180'
														: '',
												], "h-4 w-4 transform arrow--icon-menu"]),
                                        name: "das--chevron-down"
                                      }, null, 8, ["class"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      (item.subs)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subs, (s) => {
                              return (_openBlock(), _createBlock(_component_router_link, {
                                key: s.id,
                                class: _normalizeClass(
												_ctx.isSubActive.includes(s?.id)
													? 'router-link-active'
													: ''
											),
                                to: s.link
                              }, {
                                default: _withCtx(() => [
                                  (
													(!s.guard ||
														s.guard.includes(
															_ctx.profile?.staff?.role
														)) &&
													s.isGuard
												)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass([[
													s.id === '2'
														? 'side-menu--active'
														: '',
													_ctx.checkState(s.state)
														? 'grey-out'
														: '',
												], "__menu__sub px-6 py-4 hover:bg-yellow-100 cursor-pointer text-neutral-500 justify-between flex flex-nowrap items-center"])
                                      }, [
                                        _createElementVNode("div", _hoisted_19, [
                                          _hoisted_20,
                                          _createElementVNode("div", _hoisted_21, _toDisplayString(s.name), 1)
                                        ])
                                      ], 2))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["class", "to"]))
                            }), 128))
                          ], 512)), [
                            [_vShow, 
											_ctx.isSubOpen === item.id ||
											_ctx.haveSub(item.subs)
										]
                          ])
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_14))
            }), 128))
          ]),
          (_ctx.isShowHTCS)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_22,
                (_ctx.profile.orgs.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Hệ thống cơ sở "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondMenu, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: "__menu__wrapper mb-1",
                      onClick: ($event: any) => (_ctx.subOpen(item.id))
                    }, [
                      (
										!item.guard ||
										item.guard.includes(
											_ctx.profile?.staff?.role
										)
									)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.link ? `router-link` : `div`), {
                            key: 0,
                            class: _normalizeClass(
										_ctx.menuCode === item.menu
											? 'router-link-active'
											: ''
									),
                            to: item.link
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass([[
											_ctx.haveSub(item.subs)
												? 'text-yellow-700'
												: '',
											_ctx.checkState(item.state)
												? 'grey-out'
												: '',
										], "__menu__item px-6 py-4 hover:bg-yellow-100 cursor-pointer text-neutral-500 justify-between flex flex-nowrap items-center"])
                              }, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_DaIcon, {
                                      name: item.icon,
                                      class: "w-4"
                                    }, null, 8, ["name"])
                                  ]),
                                  _createElementVNode("div", _hoisted_27, _toDisplayString(item.name), 1)
                                ]),
                                (item.subs)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                      _createVNode(_component_DaIcon, {
                                        class: _normalizeClass([
													_ctx.isSubOpen === item.id ||
													_ctx.haveSub(item.subs)
														? 'rotate-180'
														: ''
												, "h-4 w-4 transform arrow--icon-menu"]),
                                        name: "das--chevron-down"
                                      }, null, 8, ["class"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ]),
                            _: 2
                          }, 1032, ["class", "to"]))
                        : _createCommentVNode("", true),
                      (item.subs)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_29, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subs, (s) => {
                              return (_openBlock(), _createBlock(_component_router_link, {
                                key: s.id,
                                class: _normalizeClass(
												_ctx.isSubActive.includes(s?.id)
													? 'router-link-active'
													: ''
											),
                                to: s.link
                              }, {
                                default: _withCtx(() => [
                                  (
													(!s.guard ||
														s.guard.includes(
															_ctx.profile?.staff?.role
														)) &&
													s.isGuard
												)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass([
													s.id === '2'
														? 'side-menu--active'
														: ''
												, "__menu__sub px-6 py-4 hover:bg-yellow-100 cursor-pointer text-neutral-500 justify-between flex flex-nowrap items-center"])
                                      }, [
                                        _createElementVNode("div", _hoisted_30, [
                                          _hoisted_31,
                                          _createElementVNode("div", _hoisted_32, _toDisplayString(s.name), 1)
                                        ])
                                      ], 2))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["class", "to"]))
                            }), 128))
                          ], 512)), [
                            [_vShow, 
											_ctx.isSubOpen === item.id ||
											_ctx.haveSub(item.subs)
										]
                          ])
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_25))
                  }), 128))
                ])
              ], 64))
            : _createCommentVNode("", true),
          _hoisted_33,
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", {
                class: _normalizeClass([
									_ctx.$route.fullPath == '/profile'
										? 'side-menu--active'
										: ''
								, "__menu__item px-6 py-4 hover:bg-yellow-100 cursor-pointer text-neutral-500 justify-between flex flex-nowrap items-center"]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/profile')))
              }, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", null, [
                    (
												_ctx.profile?.staff?.profile_photo
													?.w200
											)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: 
												_ctx.profile?.staff?.profile_photo
													?.w200
											,
                          alt: "",
                          class: "shadow-sm inline-block h-10 w-10 rounded-full"
                        }, null, 8, _hoisted_38))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          style: _normalizeStyle({
												background:
													_ctx.profile?.staff
														?.profile_photo?.default
														?.color,
											}),
                          class: "inline-flex items-center justify-center h-10 w-10 rounded-full"
                        }, [
                          _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.profile?.staff
														?.profile_photo?.default
														?.initial), 1)
                        ], 4))
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    (_ctx.profile?.staff?.name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.profile?.staff?.name), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_42, "Xin chào")),
                    _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$filters.role(
													_ctx.profile?.staff?.role
												)), 1)
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: "__menu__item px-6 py-4 hover:bg-yellow-100 cursor-pointer text-neutral-500 justify-between flex flex-nowrap items-center",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('logout')))
              }, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_DaIcon, {
                      class: "w-4",
                      name: "das--out"
                    })
                  ]),
                  _hoisted_45
                ])
              ]),
              _hoisted_46
            ])
          ])
        ])
      ])
    ])
  ]))
}